import { render, staticRenderFns } from "./SelectRelationGroup.vue?vue&type=template&id=cd5ee53a"
import script from "./SelectRelationGroup.vue?vue&type=script&lang=js"
export * from "./SelectRelationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports